module.exports = __webpack_public_path__ + "img/network.cd8f7617.svg";